import React from "react";
import { Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Sidebar.scss";
import logo from "../assets/images/logo.svg";
import s6Icon from "../assets/images/icons/s6.svg";
import {
  LuLayoutDashboard,
  LuUsers,
  LuPhone,
  LuMessageCircleQuestion,
  LuBrain,
  LuCloud,
} from "react-icons/lu";
import { IoChatbubblesOutline } from "react-icons/io5";

const Sidebar = () => {
  const { logout } = useAuth();
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const navigationItems = [
    {
      path: "/dashboard",
      label: "Dashboard",
      icon: LuLayoutDashboard,
    },
    {
      path: "/users",
      label: "User Management",
      icon: LuUsers,
    },
    {
      path: "/user-enquiries",
      label: "User Enquiries",
      icon: LuMessageCircleQuestion,
    },
    {
      path: "/ai-feedback",
      label: "AI Feedback",
      icon: LuBrain,
    },
    // {
    //   path: "/integrations",
    //   label: "Integrations",
    //   icon: GrIntegration,
    // },
    // {
    //   path: "/webhooks",
    //   label: "Webhooks",
    //   icon: LuWebhook,
    // },
    {
      path: "/recordings",
      label: "Call Recordings",
      icon: LuPhone,
    },
    // {
    //   path: "/chats",
    //   label: "Chat History",
    //   icon: IoChatbubblesOutline,
    // },
    // {
    //   path: "/aws-s3",
    //   label: "AWS S3 Recordings",
    //   icon: LuCloud,
    // },
    {
      path: "/trengo",
      label: "Trengo Integration",
      icon: s6Icon,
      isImage: true,
    },
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-content">
        <div className="sidebar-logo">
          <img src={logo} alt="logo" />
        </div>

        <Nav className="sidebar-nav">
          {navigationItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <Nav.Item key={item.path}>
                <Link
                  to={item.path}
                  className={`nav-link ${isActive(item.path) ? "active" : ""}`}
                >
                  <span className="nav-icon">
                    {item.isImage ? (
                      <img src={item.icon} alt={item.label} />
                    ) : (
                      <IconComponent />
                    )}
                  </span>
                  {item.label}
                </Link>
              </Nav.Item>
            );
          })}
        </Nav>

        <div className="sidebar-user">
        
          <button onClick={logout} className=" btn-primary w-100">
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
